const GridContainer = ({ className = '', children }) => {
  return (
    <div className={`grid grid-cols-8 md:grid-cols-9 gap-8 md:gap-20 ${className}`}>{children}</div>
  )
}

export default GridContainer
